// extracted by mini-css-extract-plugin
module.exports = {"introduction":"introduction__Z3z6n","button-wrapper":"button-wrapper__2TY8m","pane":"pane__1exJI","button":"button__13z9O"};